import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorNutrition = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Normal"
        return "green";
      case 1:
        textRisk = "Sobrepeso"
        return "yellow";
      case 2:
        textRisk = "Obesidad tipo 1"
        return "yellow";
      case 3:
        textRisk = "Obesidad tipo 2"
        return "red";
      case 4:
        textRisk = "Obesidad tipo 3"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h1 className="category-title">{category}</h1>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorNutrition;
